var map = {
	"./arrow_left.png": "6dd0",
	"./arrow_right.png": "7dc7",
	"./bg_index-cover.png": "cdaf",
	"./bg_series-index.png": "59a1",
	"./bg_series-list.png": "ca4f",
	"./bg_series.png": "7222",
	"./bg_title.png": "82ff",
	"./btn_back.png": "6813",
	"./de-DE/btn_random.png": "54d6",
	"./de-DE/img_series-101.png": "9878",
	"./de-DE/img_series-102.png": "089c",
	"./de-DE/img_series-103.png": "19df",
	"./de-DE/img_series-104.png": "cc79",
	"./de-DE/img_series-105.png": "4608",
	"./de-DE/img_series-106.png": "edfe7",
	"./de-DE/img_series-107.png": "e5a5",
	"./de-DE/img_series-108.png": "1b16",
	"./de-DE/img_series-109.png": "8342",
	"./de-DE/img_series-110.png": "e589",
	"./de-DE/img_series-111.png": "6375",
	"./de-DE/img_series-112.png": "a512",
	"./de-DE/img_series-113.png": "98d4",
	"./de-DE/img_series-114.png": "5588",
	"./de-DE/img_series-115.png": "18d9",
	"./de-DE/img_series-116.png": "2c52",
	"./de-DE/text_back.png": "2d89",
	"./de-DE/text_select-hero.png": "f015",
	"./de-DE/txt_series-101.png": "23d7",
	"./de-DE/txt_series-102.png": "428a",
	"./de-DE/txt_series-103.png": "e379",
	"./de-DE/txt_series-104.png": "7467",
	"./de-DE/txt_series-105.png": "cb00",
	"./de-DE/txt_series-106.png": "530d",
	"./de-DE/txt_series-107.png": "7bd6",
	"./de-DE/txt_series-108.png": "33f1",
	"./de-DE/txt_series-109.png": "860a",
	"./de-DE/txt_series-110.png": "d66d",
	"./de-DE/txt_series-111.png": "a766",
	"./de-DE/txt_series-112.png": "cfc7",
	"./de-DE/txt_series-113.png": "7eef",
	"./de-DE/txt_series-114.png": "9a6c",
	"./de-DE/txt_series-115.png": "8f8a",
	"./de-DE/txt_series-116.png": "4e5a",
	"./en-GB/btn_random.png": "ff15",
	"./en-GB/img_series-101.png": "70a0",
	"./en-GB/img_series-102.png": "40b7",
	"./en-GB/img_series-103.png": "ac9c",
	"./en-GB/img_series-104.png": "0143",
	"./en-GB/img_series-105.png": "057d",
	"./en-GB/img_series-106.png": "7c5a",
	"./en-GB/img_series-107.png": "fe3e",
	"./en-GB/img_series-108.png": "8b6d",
	"./en-GB/img_series-109.png": "4233",
	"./en-GB/img_series-110.png": "546c",
	"./en-GB/img_series-111.png": "7366",
	"./en-GB/img_series-112.png": "ca69",
	"./en-GB/img_series-113.png": "ec6c",
	"./en-GB/img_series-114.png": "9d29",
	"./en-GB/img_series-115.png": "5c94",
	"./en-GB/img_series-116.png": "f170",
	"./en-GB/text_back.png": "04ef",
	"./en-GB/text_select-hero.png": "b070",
	"./en-GB/txt_series-101.png": "c277",
	"./en-GB/txt_series-102.png": "8283",
	"./en-GB/txt_series-103.png": "480d",
	"./en-GB/txt_series-104.png": "ba12",
	"./en-GB/txt_series-105.png": "eb8c",
	"./en-GB/txt_series-106.png": "b021",
	"./en-GB/txt_series-107.png": "53ae",
	"./en-GB/txt_series-108.png": "e04d",
	"./en-GB/txt_series-109.png": "8dba",
	"./en-GB/txt_series-110.png": "eaf3",
	"./en-GB/txt_series-111.png": "1f63",
	"./en-GB/txt_series-112.png": "55b6",
	"./en-GB/txt_series-113.png": "6710",
	"./en-GB/txt_series-114.png": "62ac",
	"./en-GB/txt_series-115.png": "23e5",
	"./en-GB/txt_series-116.png": "9e94",
	"./en-US/btn_random.png": "eb4b",
	"./en-US/img_series-101.png": "31d5",
	"./en-US/img_series-102.png": "b49a",
	"./en-US/img_series-103.png": "9722",
	"./en-US/img_series-104.png": "86cf",
	"./en-US/img_series-105.png": "0fd1",
	"./en-US/img_series-106.png": "8324",
	"./en-US/img_series-107.png": "508b",
	"./en-US/img_series-108.png": "b694",
	"./en-US/img_series-109.png": "a74a",
	"./en-US/img_series-110.png": "02ae",
	"./en-US/img_series-111.png": "a837",
	"./en-US/img_series-112.png": "8db0",
	"./en-US/img_series-113.png": "278b",
	"./en-US/img_series-114.png": "7e1d",
	"./en-US/img_series-115.png": "dab7",
	"./en-US/img_series-116.png": "b367",
	"./en-US/text_back.png": "dba9",
	"./en-US/text_select-hero.png": "19e5",
	"./en-US/txt_index-a-s.png": "1583",
	"./en-US/txt_index-a.png": "f6c6",
	"./en-US/txt_index-b-s.png": "e855",
	"./en-US/txt_index-b.png": "e1ff",
	"./en-US/txt_index-c-s.png": "5d65",
	"./en-US/txt_index-c.png": "5a83",
	"./en-US/txt_index-d-s.png": "e339",
	"./en-US/txt_index-d.png": "f701",
	"./en-US/txt_index-e-s.png": "b79a",
	"./en-US/txt_index-e.png": "4e3d",
	"./en-US/txt_index-f-s.png": "22f9",
	"./en-US/txt_index-f.png": "5fab",
	"./en-US/txt_index-g-s.png": "757c",
	"./en-US/txt_index-g.png": "aa02",
	"./en-US/txt_index-h-s.png": "938c",
	"./en-US/txt_index-h.png": "87ba",
	"./en-US/txt_index-i-s.png": "e17a",
	"./en-US/txt_index-i.png": "386d",
	"./en-US/txt_index-j-s.png": "a5af",
	"./en-US/txt_index-j.png": "3110",
	"./en-US/txt_index-k-s.png": "7820",
	"./en-US/txt_index-k.png": "2ba4",
	"./en-US/txt_index-l-s.png": "feba",
	"./en-US/txt_index-l.png": "40cc",
	"./en-US/txt_index-m-s.png": "61d2",
	"./en-US/txt_index-m.png": "12b9",
	"./en-US/txt_index-n-s.png": "c149",
	"./en-US/txt_index-n.png": "63bb",
	"./en-US/txt_index-o-s.png": "a8b8",
	"./en-US/txt_index-o.png": "a217",
	"./en-US/txt_index-p-s.png": "d434",
	"./en-US/txt_index-p.png": "0058",
	"./en-US/txt_index-q-s.png": "8897",
	"./en-US/txt_index-q.png": "f797",
	"./en-US/txt_index-r-s.png": "e4b9",
	"./en-US/txt_index-r.png": "e62f",
	"./en-US/txt_index-s-s.png": "ea70",
	"./en-US/txt_index-s.png": "5bd5",
	"./en-US/txt_index-t-s.png": "6d83",
	"./en-US/txt_index-t.png": "bffd",
	"./en-US/txt_index-u-s.png": "35c7",
	"./en-US/txt_index-u.png": "eb88",
	"./en-US/txt_index-v-s.png": "cf0e",
	"./en-US/txt_index-v.png": "3d05",
	"./en-US/txt_index-w-s.png": "1ba7",
	"./en-US/txt_index-w.png": "0369",
	"./en-US/txt_index-x-s.png": "bba9",
	"./en-US/txt_index-x.png": "2111",
	"./en-US/txt_index-y-s.png": "3884",
	"./en-US/txt_index-y.png": "b0b6",
	"./en-US/txt_index-z-s.png": "4f84",
	"./en-US/txt_index-z.png": "4f4c",
	"./en-US/txt_series-101.png": "0db3",
	"./en-US/txt_series-102.png": "2449",
	"./en-US/txt_series-103.png": "b62d",
	"./en-US/txt_series-104.png": "d995",
	"./en-US/txt_series-105.png": "01b6",
	"./en-US/txt_series-106.png": "36c8",
	"./en-US/txt_series-107.png": "8033",
	"./en-US/txt_series-108.png": "9c34",
	"./en-US/txt_series-109.png": "4715",
	"./en-US/txt_series-110.png": "d3e9",
	"./en-US/txt_series-111.png": "707f",
	"./en-US/txt_series-112.png": "97e2",
	"./en-US/txt_series-113.png": "ef4d",
	"./en-US/txt_series-114.png": "298e",
	"./en-US/txt_series-115.png": "3450",
	"./en-US/txt_series-116.png": "8719",
	"./es-ES/btn_random.png": "20e6",
	"./es-ES/img_series-101.png": "dc1a",
	"./es-ES/img_series-102.png": "9e75",
	"./es-ES/img_series-103.png": "9191",
	"./es-ES/img_series-104.png": "cd5d",
	"./es-ES/img_series-105.png": "38e2",
	"./es-ES/img_series-106.png": "a9df",
	"./es-ES/img_series-107.png": "621c",
	"./es-ES/img_series-108.png": "7687",
	"./es-ES/img_series-109.png": "ba39",
	"./es-ES/img_series-110.png": "ccd6",
	"./es-ES/img_series-111.png": "fb69",
	"./es-ES/img_series-112.png": "8b2f",
	"./es-ES/img_series-113.png": "aea9",
	"./es-ES/img_series-114.png": "96ce",
	"./es-ES/img_series-115.png": "f063",
	"./es-ES/img_series-116.png": "0588",
	"./es-ES/text_back.png": "c803",
	"./es-ES/text_select-hero.png": "5a3c",
	"./es-ES/txt_series-101.png": "6481",
	"./es-ES/txt_series-102.png": "22aa",
	"./es-ES/txt_series-103.png": "7e29",
	"./es-ES/txt_series-104.png": "e024",
	"./es-ES/txt_series-105.png": "46e6",
	"./es-ES/txt_series-106.png": "d6d7",
	"./es-ES/txt_series-107.png": "0b8a",
	"./es-ES/txt_series-108.png": "cb6e",
	"./es-ES/txt_series-109.png": "da78",
	"./es-ES/txt_series-110.png": "e532",
	"./es-ES/txt_series-111.png": "2f8c",
	"./es-ES/txt_series-112.png": "703b",
	"./es-ES/txt_series-113.png": "9ee6",
	"./es-ES/txt_series-114.png": "7870",
	"./es-ES/txt_series-115.png": "4f6d",
	"./es-ES/txt_series-116.png": "d5bf",
	"./es-MX/btn_random.png": "6d9e",
	"./es-MX/img_series-101.png": "21e2",
	"./es-MX/img_series-102.png": "2d61",
	"./es-MX/img_series-103.png": "f8c9",
	"./es-MX/img_series-104.png": "4aa8",
	"./es-MX/img_series-105.png": "0572",
	"./es-MX/img_series-106.png": "8a47",
	"./es-MX/img_series-107.png": "e2c2",
	"./es-MX/img_series-108.png": "744e",
	"./es-MX/img_series-109.png": "c582",
	"./es-MX/img_series-110.png": "0adc",
	"./es-MX/img_series-111.png": "4ef5",
	"./es-MX/img_series-112.png": "88e5",
	"./es-MX/img_series-113.png": "a482",
	"./es-MX/img_series-114.png": "5029",
	"./es-MX/img_series-115.png": "352b",
	"./es-MX/img_series-116.png": "535b",
	"./es-MX/text_back.png": "7c4b",
	"./es-MX/text_select-hero.png": "7ff6",
	"./es-MX/txt_series-101.png": "a0b4",
	"./es-MX/txt_series-102.png": "aed0",
	"./es-MX/txt_series-103.png": "87b9",
	"./es-MX/txt_series-104.png": "ecee",
	"./es-MX/txt_series-105.png": "24c5",
	"./es-MX/txt_series-106.png": "e0d3",
	"./es-MX/txt_series-107.png": "18b9",
	"./es-MX/txt_series-108.png": "7a3c",
	"./es-MX/txt_series-109.png": "38dc",
	"./es-MX/txt_series-110.png": "d88e",
	"./es-MX/txt_series-111.png": "4057",
	"./es-MX/txt_series-112.png": "24ef",
	"./es-MX/txt_series-113.png": "6bc2",
	"./es-MX/txt_series-114.png": "97e5",
	"./es-MX/txt_series-115.png": "abf2",
	"./es-MX/txt_series-116.png": "0c37",
	"./fr-CA/btn_random.png": "6835",
	"./fr-CA/img_series-101.png": "b1f5",
	"./fr-CA/img_series-102.png": "412b",
	"./fr-CA/img_series-103.png": "4fe5",
	"./fr-CA/img_series-104.png": "3f64",
	"./fr-CA/img_series-105.png": "83bd",
	"./fr-CA/img_series-106.png": "7a44",
	"./fr-CA/img_series-107.png": "f7b7",
	"./fr-CA/img_series-108.png": "23b8",
	"./fr-CA/img_series-109.png": "7481",
	"./fr-CA/img_series-110.png": "c078",
	"./fr-CA/img_series-111.png": "07e6",
	"./fr-CA/img_series-112.png": "6cb2",
	"./fr-CA/img_series-113.png": "ee90",
	"./fr-CA/img_series-114.png": "32c7",
	"./fr-CA/img_series-115.png": "9f71",
	"./fr-CA/img_series-116.png": "70c6",
	"./fr-CA/text_back.png": "2d71",
	"./fr-CA/text_select-hero.png": "4591",
	"./fr-CA/txt_series-101.png": "e2f8",
	"./fr-CA/txt_series-102.png": "c4fb",
	"./fr-CA/txt_series-103.png": "1831",
	"./fr-CA/txt_series-104.png": "c2bb",
	"./fr-CA/txt_series-105.png": "b7b6",
	"./fr-CA/txt_series-106.png": "2335",
	"./fr-CA/txt_series-107.png": "834e",
	"./fr-CA/txt_series-108.png": "9f51",
	"./fr-CA/txt_series-109.png": "f420",
	"./fr-CA/txt_series-110.png": "a3c9",
	"./fr-CA/txt_series-111.png": "8fec",
	"./fr-CA/txt_series-112.png": "eb24",
	"./fr-CA/txt_series-113.png": "549f",
	"./fr-CA/txt_series-114.png": "e06f",
	"./fr-CA/txt_series-115.png": "206d",
	"./fr-CA/txt_series-116.png": "be6a",
	"./fr-FR/btn_random.png": "1e76",
	"./fr-FR/img_series-101.png": "80b6",
	"./fr-FR/img_series-102.png": "d772",
	"./fr-FR/img_series-103.png": "ca1b",
	"./fr-FR/img_series-104.png": "a7f8",
	"./fr-FR/img_series-105.png": "df67",
	"./fr-FR/img_series-106.png": "f413",
	"./fr-FR/img_series-107.png": "de9e",
	"./fr-FR/img_series-108.png": "03a0",
	"./fr-FR/img_series-109.png": "4cbe",
	"./fr-FR/img_series-110.png": "bc27",
	"./fr-FR/img_series-111.png": "f904",
	"./fr-FR/img_series-112.png": "a63e",
	"./fr-FR/img_series-113.png": "ebe6",
	"./fr-FR/img_series-114.png": "e1c8",
	"./fr-FR/img_series-115.png": "9604",
	"./fr-FR/img_series-116.png": "bb5a",
	"./fr-FR/text_back.png": "429c",
	"./fr-FR/text_select-hero.png": "e569",
	"./fr-FR/txt_series-101.png": "05ab",
	"./fr-FR/txt_series-102.png": "173b",
	"./fr-FR/txt_series-103.png": "78e2",
	"./fr-FR/txt_series-104.png": "7c7d",
	"./fr-FR/txt_series-105.png": "1fa3",
	"./fr-FR/txt_series-106.png": "4838",
	"./fr-FR/txt_series-107.png": "8fab",
	"./fr-FR/txt_series-108.png": "1860",
	"./fr-FR/txt_series-109.png": "b5ee",
	"./fr-FR/txt_series-110.png": "d8d7",
	"./fr-FR/txt_series-111.png": "34f4",
	"./fr-FR/txt_series-112.png": "b10c",
	"./fr-FR/txt_series-113.png": "1707",
	"./fr-FR/txt_series-114.png": "3629",
	"./fr-FR/txt_series-115.png": "010e",
	"./fr-FR/txt_series-116.png": "a729",
	"./it-IT/btn_random.png": "023c",
	"./it-IT/img_series-101.png": "5c3f",
	"./it-IT/img_series-102.png": "3351",
	"./it-IT/img_series-103.png": "5d0f",
	"./it-IT/img_series-104.png": "44e4",
	"./it-IT/img_series-105.png": "01ba",
	"./it-IT/img_series-106.png": "486a",
	"./it-IT/img_series-107.png": "a042",
	"./it-IT/img_series-108.png": "3e48",
	"./it-IT/img_series-109.png": "5e9c",
	"./it-IT/img_series-110.png": "aabc",
	"./it-IT/img_series-111.png": "ba11",
	"./it-IT/img_series-112.png": "f3b2",
	"./it-IT/img_series-113.png": "b51c",
	"./it-IT/img_series-114.png": "e0b8",
	"./it-IT/img_series-115.png": "7ebe",
	"./it-IT/img_series-116.png": "7d3b",
	"./it-IT/text_back.png": "03e8",
	"./it-IT/text_select-hero.png": "6dbc",
	"./it-IT/txt_series-101.png": "d4d5",
	"./it-IT/txt_series-102.png": "3aa3",
	"./it-IT/txt_series-103.png": "03df",
	"./it-IT/txt_series-104.png": "a3b3",
	"./it-IT/txt_series-105.png": "9ec0",
	"./it-IT/txt_series-106.png": "ac7b",
	"./it-IT/txt_series-107.png": "e5f9",
	"./it-IT/txt_series-108.png": "02ab",
	"./it-IT/txt_series-109.png": "f04c",
	"./it-IT/txt_series-110.png": "8769",
	"./it-IT/txt_series-111.png": "6a00",
	"./it-IT/txt_series-112.png": "4670",
	"./it-IT/txt_series-113.png": "0a07",
	"./it-IT/txt_series-114.png": "130a",
	"./it-IT/txt_series-115.png": "7f66",
	"./it-IT/txt_series-116.png": "bcce",
	"./ja-JP/btn_random.png": "68ff",
	"./ja-JP/img_series-101.png": "cc71",
	"./ja-JP/img_series-102.png": "853d",
	"./ja-JP/img_series-103.png": "d37d",
	"./ja-JP/img_series-104.png": "bd58",
	"./ja-JP/img_series-105.png": "46ed",
	"./ja-JP/img_series-106.png": "60b4",
	"./ja-JP/img_series-107.png": "2b4a",
	"./ja-JP/img_series-108.png": "6c00",
	"./ja-JP/img_series-109.png": "c97d",
	"./ja-JP/img_series-110.png": "1103",
	"./ja-JP/img_series-111.png": "01b4",
	"./ja-JP/img_series-112.png": "00a7",
	"./ja-JP/img_series-113.png": "4757",
	"./ja-JP/img_series-114.png": "44f2",
	"./ja-JP/img_series-115.png": "fec6d",
	"./ja-JP/img_series-116.png": "0062",
	"./ja-JP/text_back.png": "2e34",
	"./ja-JP/text_select-hero.png": "fe34",
	"./ja-JP/txt_index-a-s.png": "d9f2",
	"./ja-JP/txt_index-a.png": "447e",
	"./ja-JP/txt_index-ha-s.png": "6b25",
	"./ja-JP/txt_index-ha.png": "2a4b",
	"./ja-JP/txt_index-ka-s.png": "0895",
	"./ja-JP/txt_index-ka.png": "9791",
	"./ja-JP/txt_index-ma-s.png": "d499",
	"./ja-JP/txt_index-ma.png": "d15a",
	"./ja-JP/txt_index-n-s.png": "257e",
	"./ja-JP/txt_index-n.png": "229d",
	"./ja-JP/txt_index-na-s.png": "cd6c",
	"./ja-JP/txt_index-na.png": "f845",
	"./ja-JP/txt_index-ra-s.png": "eaf5",
	"./ja-JP/txt_index-ra.png": "f75b",
	"./ja-JP/txt_index-sa-s.png": "4ed6",
	"./ja-JP/txt_index-sa.png": "4de5",
	"./ja-JP/txt_index-ta-s.png": "09e7",
	"./ja-JP/txt_index-ta.png": "6b50",
	"./ja-JP/txt_index-wa-s.png": "cf60",
	"./ja-JP/txt_index-wa.png": "aeb0",
	"./ja-JP/txt_index-wo-s.png": "8d42",
	"./ja-JP/txt_index-wo.png": "bb7a",
	"./ja-JP/txt_index-ya-s.png": "591f",
	"./ja-JP/txt_index-ya.png": "2cc5",
	"./ja-JP/txt_series-101.png": "b246",
	"./ja-JP/txt_series-102.png": "ee09",
	"./ja-JP/txt_series-103.png": "45b1",
	"./ja-JP/txt_series-104.png": "aff6",
	"./ja-JP/txt_series-105.png": "d4f7",
	"./ja-JP/txt_series-106.png": "85fa",
	"./ja-JP/txt_series-107.png": "89b8",
	"./ja-JP/txt_series-108.png": "9426",
	"./ja-JP/txt_series-109.png": "364c",
	"./ja-JP/txt_series-110.png": "e2f0",
	"./ja-JP/txt_series-111.png": "b25b",
	"./ja-JP/txt_series-112.png": "a434",
	"./ja-JP/txt_series-113.png": "0afc",
	"./ja-JP/txt_series-114.png": "8114",
	"./ja-JP/txt_series-115.png": "e641",
	"./ja-JP/txt_series-116.png": "592c",
	"./lin_character-list.png": "6879",
	"./pt-BR/btn_random.png": "d17a",
	"./pt-BR/img_series-101.png": "9f9f",
	"./pt-BR/img_series-102.png": "3b71",
	"./pt-BR/img_series-103.png": "42d4",
	"./pt-BR/img_series-104.png": "ffbf",
	"./pt-BR/img_series-105.png": "379a",
	"./pt-BR/img_series-106.png": "5320",
	"./pt-BR/img_series-107.png": "1cc6",
	"./pt-BR/img_series-108.png": "887a",
	"./pt-BR/img_series-109.png": "3194",
	"./pt-BR/img_series-110.png": "9dbd",
	"./pt-BR/img_series-111.png": "c78c",
	"./pt-BR/img_series-112.png": "02b7",
	"./pt-BR/img_series-113.png": "110f",
	"./pt-BR/img_series-114.png": "45d4",
	"./pt-BR/img_series-115.png": "8e69",
	"./pt-BR/img_series-116.png": "0cdd",
	"./pt-BR/text_back.png": "434a",
	"./pt-BR/text_select-hero.png": "c46e",
	"./pt-BR/txt_series-101.png": "21d2",
	"./pt-BR/txt_series-102.png": "8309",
	"./pt-BR/txt_series-103.png": "36f3",
	"./pt-BR/txt_series-104.png": "2a22",
	"./pt-BR/txt_series-105.png": "0546",
	"./pt-BR/txt_series-106.png": "4af2",
	"./pt-BR/txt_series-107.png": "1282",
	"./pt-BR/txt_series-108.png": "bc02",
	"./pt-BR/txt_series-109.png": "0f86",
	"./pt-BR/txt_series-110.png": "9953",
	"./pt-BR/txt_series-111.png": "1bbc",
	"./pt-BR/txt_series-112.png": "ce1b",
	"./pt-BR/txt_series-113.png": "c03f",
	"./pt-BR/txt_series-114.png": "dd8f",
	"./pt-BR/txt_series-115.png": "b2bc",
	"./pt-BR/txt_series-116.png": "89de",
	"./zh-TW/btn_random.png": "f470",
	"./zh-TW/img_series-101.png": "8298",
	"./zh-TW/img_series-102.png": "c719",
	"./zh-TW/img_series-103.png": "576a",
	"./zh-TW/img_series-104.png": "a136",
	"./zh-TW/img_series-105.png": "6c44",
	"./zh-TW/img_series-106.png": "ce57",
	"./zh-TW/img_series-107.png": "e001",
	"./zh-TW/img_series-108.png": "aeb5",
	"./zh-TW/img_series-109.png": "a4a5",
	"./zh-TW/img_series-110.png": "550d",
	"./zh-TW/img_series-111.png": "0de1",
	"./zh-TW/img_series-112.png": "871a",
	"./zh-TW/img_series-113.png": "bea4",
	"./zh-TW/img_series-114.png": "cbdb",
	"./zh-TW/img_series-115.png": "d523",
	"./zh-TW/img_series-116.png": "5a04",
	"./zh-TW/text_back.png": "09fe",
	"./zh-TW/text_select-hero.png": "6bde",
	"./zh-TW/txt_series-101.png": "bec3",
	"./zh-TW/txt_series-102.png": "9710",
	"./zh-TW/txt_series-103.png": "1b47",
	"./zh-TW/txt_series-104.png": "f827",
	"./zh-TW/txt_series-105.png": "ca61",
	"./zh-TW/txt_series-106.png": "6040",
	"./zh-TW/txt_series-107.png": "73bb",
	"./zh-TW/txt_series-108.png": "fa96",
	"./zh-TW/txt_series-109.png": "ce2f",
	"./zh-TW/txt_series-110.png": "9d45",
	"./zh-TW/txt_series-111.png": "6575",
	"./zh-TW/txt_series-112.png": "5828",
	"./zh-TW/txt_series-113.png": "f4c98",
	"./zh-TW/txt_series-114.png": "a0c8",
	"./zh-TW/txt_series-115.png": "1bfd",
	"./zh-TW/txt_series-116.png": "d172"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b71";